import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Margin } from 'styled-components-spacing';
import Checkmarks from 'routes/_components/layout/components/footer/components/checkmarks/Checkmarks';
import Spinner from 'routes/template/components/Spinner';
// import RecommendedHotels from 'components/recommendedHotels/RecommendedHotels';
import IntroSection from 'routes/template/components/IntroSection/IntroSection';
// import StaticMap from 'components/map/StaticMap';
import CountriesListSection from './components/CountriesListSection/CountriesListSection';
import { mediaQueries } from 'styles/utils/mediaQueries';
import loadableVisibility from 'react-loadable-visibility/loadable-components';
import InfiniteThreeDots from 'components/spinners/InfiniteThreeDots';

const RecommendedHotels = loadableVisibility(() => import('components/recommendedHotels/RecommendedHotels'), {
  fallback: <InfiniteThreeDots />,
});

function CountriesTemplateComponent({ content, displaySpinner, mapLocations, destinations }) {
  return (
    <Fragment>
      <Container>
        <IntroSectionWrap>
          <IntroSection title={content.title} description={content.description} />
        </IntroSectionWrap>
        {displaySpinner ? (
          <Spinner />
        ) : (
          <Fragment>
            {/* <MapSectionWrap>
                <StaticMap locations={mapLocations} config={{ mapOptions: { interactive: true } }} />
              </MapSectionWrap> */}

            <CountriesListSectionWrap>
              <CountriesListSection countries={destinations} />
            </CountriesListSectionWrap>
          </Fragment>
        )}
      </Container>
      <Margin top='5' />
      <RecommendedHotels />
      <Checkmarks hideHighlights />
    </Fragment>
  );
}

export default CountriesTemplateComponent;

const Container = styled.div`
  width: 1024px;
  margin: 0 auto;
  padding: 0 15px;

  ${mediaQueries.fromAndBelow.desktop`
    width: 750px;
  `}

  ${mediaQueries.fromAndBelow.tablet`
    width: 100%;
  `}
`;

const SectionWrap = styled.div`
  margin: 100px 0 0;
`;

const IntroSectionWrap = styled(SectionWrap)``;

const MapSectionWrap = styled(SectionWrap)`
  ${mediaQueries.fromAndBelow.tablet`
    margin-top: 50px;
  `}
`;

const CountriesListSectionWrap = styled(SectionWrap)``;
